import React, { Component, useEffect } from "react";
import { NavLink, Route, Routes } from "react-router-dom";
import $ from "jquery";

class Mainmenu extends Component {
  callJQueryFunction = () => {
    // Call your jQuery function
    $("#sidebarToggle, #sidebarToggleTop").on("click", function (e) {
      $("body").toggleClass("sidebar-toggled");
      $(".sidebar").toggleClass("toggled");
      if ($(".sidebar").hasClass("toggled")) {
        //$(".sidebar .collapse").collapse(); //.collapse('hide');
      }
    });
  };

  render() {
    const handlePatientadd = () => {
      sessionStorage.setItem("pat_id", 0);
    };

    const handleNewTemplate = () => {
      sessionStorage.removeItem("edit_tmpl_id");
      sessionStorage.removeItem("add_tmpl_fld");
    };

    const handlePatientNewClick = () => {
      sessionStorage.removeItem("tmpl_rec");
      clearPedigreeSessionStorage();
    };

    const clearPedigreeSessionStorage = () => {
      var prefix = "PEDIGREE_history_";
      for (let key in sessionStorage) {
        if (key.startsWith(prefix)) {
          sessionStorage.removeItem(key);
        }
      }
      sessionStorage.removeItem("pat_padigree");
    };
    return (
      <>
        <ul
          className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
          id="accordionSidebar"
        >
          <a
            className="sidebar-brand d-flex align-items-center justify-content-center"
            href="."
          >
            <div className="sidebar-brand-icon">&nbsp;</div>
          </a>
          <hr className="sidebar-divider my-0" />
          {/*<li className="nav-item">
            <NavLink to="/dashboard" className="nav-link">
              <span>
                <i className="fas fa-fw fa-tachometer-alt"></i>Dashboard
              </span>
            </NavLink>
          </li>*/}
          <hr className="sidebar-divider" />
          <div className="sidebar-heading">Main</div>
          {/*<li className="nav-item">
            <a
              className="nav-link collapsed"
              href="#"
              data-toggle="collapse"
              data-target="#collapseTmplPage"
              aria-expanded="true"
              aria-controls="collapseTmplPage"
            >
              <i className="fas fa-file-alt"></i>
              <span>Template</span>
            </a>
            <div
              id="collapseTmplPage"
              className="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordionSidebar"
            >
              <div className="bg-white py-2 collapse-inner rounded">
                <NavLink to="/templatepage" className="collapse-item">
                  <i className="icon fas fa-pen"></i>&nbsp;Design
                </NavLink>
              </div>
            </div>
          </li>*/}
          {/* Patient */}
          {/*<li className="nav-item">
            <a
              className="nav-link collapsed"
              href="#"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <i className="fas fa-wheelchair"></i>
              <span>Patient</span>
            </a>
            <div
              id="collapseOne"
              className="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordionSidebar"
            >
              <div className="bg-white py-2 collapse-inner rounded">
                {/*<NavLink to="/patientsearch" className="collapse-item">
                  <i className=""></i>Patient
                </NavLink>
                <NavLink
                  to="/patientnew"
                  className="collapse-item"
                  onClick={() => handlePatientNewClick()}
                >
                  <i className=""></i>Patient New
                </NavLink>
                <NavLink to="/patientsearchnew" className="collapse-item">
                  <i className="fas fa-list" />
                  &nbsp;List
                </NavLink>
              </div>
            </div>
          </li>*/}
          <li className="nav-item">
            <a
              className="nav-link collapsed"
              href="#"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="true"
              aria-controls="collapseTwo"
            >
              <i className="fas fa-users"></i>
              <span>Users</span>
            </a>
            <div
              id="collapseTwo"
              className="collapse"
              aria-labelledby="headingTwo"
              data-parent="#accordionSidebar"
            >
              <div className="bg-white py-2 collapse-inner rounded">
                <NavLink to="/usersearch" className="collapse-item">
                  Search
                </NavLink>
                <NavLink to="/useradd" className="collapse-item">
                  Add
                </NavLink>
              </div>
            </div>
          </li>
          {/*<li className="nav-item">
            <a
              className="nav-link collapsed"
              href="#"
              data-toggle="collapse"
              data-target="#collapseReports"
              aria-expanded="true"
              aria-controls="collapseReports"
            >
              <i className="fas fa-file"></i>
              <span>Research</span>
            </a>
            <div
              id="collapseReports"
              className="collapse"
              aria-labelledby="headingReports"
              data-parent="#accordionSidebar"
            >
              <div className="bg-white py-2 collapse-inner rounded">
                <NavLink to="/reportlist" className="collapse-item">
                  <i className="icon fas fa-pen" />
                  &nbsp;Design Reports
                </NavLink>
              </div>
            </div>
          </li>*/}

          <li className="nav-item">
            <a
              className="nav-link collapsed"
              href="#"
              data-toggle="collapse"
              data-target="#collapseUtilities"
              aria-expanded="true"
              aria-controls="collapseUtilities"
            >
              <i className="fas fa-cog"></i>
              <span>Configurations</span>
            </a>
            <div
              id="collapseUtilities"
              className="collapse"
              aria-labelledby="headingUtilities"
              data-parent="#accordionSidebar"
            >
              <div className="bg-white py-2 collapse-inner rounded">
                <NavLink to="/surveysearch" className="collapse-item">
                  <i className="icon fas fa-tasks" />
                  &nbsp;Survey
                </NavLink>
{/*                <NavLink to="/dashboardlist" className="collapse-item">
                  <i className="icon fas fa-pen" />
                  &nbsp;Design Dashboard
                </NavLink>
*/}              </div>
            </div>
          </li>
          {/*<li className="nav-item">
            <a
              className="nav-link collapsed"
              href="#"
              data-toggle="collapse"
              data-target="#collapseTemplate"
              aria-expanded="true"
              aria-controls="collapseTemplate"
            >
              <i className="fas fa-file-alt"></i>
              <span>Template</span>
            </a>
            <div
              id="collapseTemplate"
              className="collapse"
              aria-labelledby="headingTemplate"
              data-parent="#accordionSidebar"
            >
              <div className="bg-white py-2 collapse-inner rounded">
                <NavLink to="/templateadd" className="collapse-item" onClick={handleNewTemplate}>
                <i className="fas fa-plus"></i>&nbsp;New Template
                </NavLink>
                <NavLink to="/templatesearch" className="collapse-item">
                <i className="fas fa-file-alt"></i>&nbsp;My Template
                </NavLink>
              </div>
            </div>
          </li>   */}
          <hr className="sidebar-divider" />
          {/*<div className="sidebar-heading">Research</div>
          <li className="nav-item">
            <a
              className="nav-link collapsed"
              href="#"
              data-toggle="collapse"
              data-target="#collapsePages"
              aria-expanded="true"
              aria-controls="collapsePages"
            >
              <i className="fas fa-fw fa-folder"></i>
              <span>Reports</span>
            </a>
            <div
              id="collapsePages"
              className="collapse"
              aria-labelledby="headingPages"
              data-parent="#accordionSidebar"
            >
              <div className="bg-white py-2 collapse-inner rounded">
                <h6 className="collapse-header">Reports</h6>
                <a className="collapse-item" href="login.html">
                  Patient History
                </a>
                <a className="collapse-item" href="register.html">
                  Medical Case
                </a>
                <div className="collapse-divider"></div>
                <h6 className="collapse-header">Research</h6>
                <a className="collapse-item" href="404.html">
                  Research
                </a>
                <a className="collapse-item" href="blank.html">
                  Survey
                </a>
              </div>
            </div>
          </li>*/}
          <hr className="sidebar-divider d-none d-md-block" />
          <div className="text-center d-none d-md-inline">
            {/*<button className="rounded-circle border-0" id="sidebarToggle" title="Toggle"></button>*/}
            <button
              className="rounded-circle border-0"
              id="sidebarToggle"
              title="clickMe"
              onClick={this.callJQueryFunction}
            ></button>
            {/* Render your sidebar and other content here */}
          </div>
        </ul>
      </>
    );
  }
}
export default Mainmenu;
